// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.container[data-v-0b9e10fb] {\n  margin: 0 20px 0 20px;\n}\nh2[data-v-0b9e10fb] {\n  text-align: left;\n  margin-bottom: 20px;\n  /* margin-left: 20px; */\n}\n", ""]);
// Exports
module.exports = exports;
